import React from "react";
import RoomingFormField from "../../components/RoomingFormField";
import { ReactController } from "../react_controller";

export class RoomingFieldController extends ReactController {
  connect() {
    this.root.render(<RoomingFormField {...this.propsValue} />);
  }
}
